import { render, staticRenderFns } from "./MbTestQuestion.vue?vue&type=template&id=438e0496&scoped=true&"
import script from "./MbTestQuestion.vue?vue&type=script&lang=js&"
export * from "./MbTestQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MbTestQuestion.vue?vue&type=style&index=0&id=438e0496&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438e0496",
  null
  
)

export default component.exports